import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { collectUserInput, isPopulated } from "utils/helpers";
import { getRecommendations } from "actions/recommendationsActions";
import CATEGORIES from "utils/categories";
import MasterButton, { BUTTON_TYPES } from "components/ui/MasterButton";
import { createStructuredSelector } from "reselect";
import { makeAttributeUserSelector } from "reducers/selectors";
import { ACTION_TYPE } from "reducers/actionType";
import "styles/FieldList.scss";

import "styles/SaveDraft.scss";

class NavigationFooter extends Component {
  handleSubmitFos = () => {
    // const { userStudys } = this.props;
    const userInput = collectUserInput();
    this.props.dispatch(getRecommendations(userInput));
  };

  handleClickNext = () => {};

  handleClickSkip = () => {
    this.props.onSkip();
  };

  render() {
    const { list, final, focus, onBack, studies } = this.props;
    if (studies) {
      const { userStudys } = this.props;
      const noStudys = userStudys.length === 0;
      return (
        <div className={focus ? "hide" : "window-sticky"}>
          <div className="desktop-and-tablet window-sticky-inner">
            <NavLink to="/course-areas">
              <MasterButton type={BUTTON_TYPES.SECONDARY} text="Cancel" />
            </NavLink>
            <NavLink to="/summary">
              <MasterButton
                type={BUTTON_TYPES.PRIMARY}
                disabled={noStudys}
                text={"Next"}
                callback={this.handleSubmitFos}
              />
            </NavLink>
          </div>

          <div className="mobile-only">
            <div className="window-sticky-inner">
              <NavLink to="/course-areas">
                <MasterButton type={BUTTON_TYPES.SECONDARY} text="Cancel" />
              </NavLink>
              <NavLink to="/summary">
                <MasterButton
                  type={BUTTON_TYPES.PRIMARY}
                  disabled={noStudys}
                  text={"Next"}
                  callback={this.handleSubmitFos}
                />
              </NavLink>
            </div>
          </div>
        </div>
      );
    }

    // if this is the last category,
    // and nothing has been selected for this category,
    // and nothing has been selected for other categories,
    // disable ability to continue entirely
    if (
      final &&
      CATEGORIES.filter((cat) => cat.contributor).every(
        (contri) => !isPopulated(contri)
      )
    ) {
      return (
        <div className={focus ? "hide" : "window-sticky"}>
          <div className="desktop-and-tablet window-sticky-inner">
            <MasterButton
              type={BUTTON_TYPES.SECONDARY}
              disabled={true}
              text={list ? "Back" : "Skip"}
            />
            <MasterButton
              type={BUTTON_TYPES.PRIMARY}
              disabled={true}
              text={"Next"}
            />
          </div>

          <div className="mobile-only">
            <div className="window-sticky-inner">
              <MasterButton
                type={BUTTON_TYPES.SECONDARY}
                disabled={list ? false : true}
                text={list ? "Back" : "Skip"}
              />
              <MasterButton
                type={BUTTON_TYPES.PRIMARY}
                disabled={true}
                text={"Next"}
              />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className={focus ? "hide" : "window-sticky"}>
          <div className="desktop-and-tablet window-sticky-inner">
            {list ? (
              <MasterButton
                type={BUTTON_TYPES.SECONDARY}
                text="Back"
                callback={onBack}
              />
            ) : (
              <NavLink to={`/${this.props.nextNavlink}`}>
                <MasterButton
                  type={BUTTON_TYPES.SECONDARY}
                  text="Skip"
                  callback={this.handleClickSkip}
                />
              </NavLink>
            )}
            <NavLink to={`/${this.props.nextNavlink}`}>
              <MasterButton
                type={BUTTON_TYPES.PRIMARY}
                callback={this.handleClickNext}
                text="Next"
              />
            </NavLink>
          </div>

          <div className="mobile-only">
            <div className="window-sticky-inner">
              {list ? (
                <MasterButton
                  type={BUTTON_TYPES.SECONDARY}
                  text="Back"
                  disabled={false}
                  callback={onBack}
                />
              ) : (
                <NavLink to={`/${this.props.nextNavlink}`}>
                  <MasterButton
                    type={BUTTON_TYPES.SECONDARY}
                    text="Skip"
                    callback={this.handleClickSkip}
                  />
                </NavLink>
              )}
              <NavLink to={`/${this.props.nextNavlink}`}>
                <MasterButton
                  type={BUTTON_TYPES.PRIMARY}
                  callback={this.handleClickNext}
                  text="Next"
                />
              </NavLink>
            </div>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (store) => {
  return createStructuredSelector({
    userStudys: makeAttributeUserSelector(ACTION_TYPE.STUDY.ACCESS),
  });
};
export default connect(mapStateToProps)(NavigationFooter);
